/* eslint-disable array-callback-return */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import DockerPanel from '../../common/DockerPanel/DockerPanel';
import BulkCancel from '../ClinicianView/CancelTreatment/BulkCancel';
import BundleVisitsDetails from '../BundleVisit/BundleVisitsDetails';
import {
  disableBundleVisitButton,
  disableAssignVisitButton,
  disableWhenAnyStatementIsTrue,
} from '../../../components/Planner/timeline/timelineDockerHelper';
import { checkFeatureAccess } from '../../../utils/helpers';
import { highlightAvailableSlots } from '../timeline/timelineHelper';
import useTimeline from '../timeline/useTimeline';
import globals from '../../../globals/communityGlobals';
import _ from '../../../utils/lodash';

const locale = globals.getArea('dailyPlanning');

export default function TimelineDockerPanel({
  items: selectedTreatments,
  clinicianIds,
  toggleRefresh,
  includeTreatments,
  onCancel,
  onSelectAll,
  setLoadingTimeSlots,
  setIsMultiAssign,
  isMultiAssign,
  baseRequestModel,
}) {
  const [showBulkCancel, setShowBulkCancel] = useState(false);
  const [showBundleVisitsSidePanel, setBundleVisitSidePanel] = useState(false);
  const faList = useSelector(store => store.global.auth.featureAccessList);
  const { getFlag, resetTreatmentClickEvent, activeTreatment, setActiveTreatment, getAccessToken } = useTimeline();

  const getAvailableTimeSpansForVisits = () => {
    if (activeTreatment) {
      setActiveTreatment(null);
    }
    if (checkFeatureAccess(faList, globals.applicationFeatureAccesses.canAllocateWork)) {
      setIsMultiAssign(true);

      const model = {};
      model.clinicianIds = clinicianIds;
      model.treatmentIds = selectedTreatments.flatMap(x => x.treatmentId);
      model.timeSlotIds = selectedTreatments.flatMap(x => x.timeSlotId);

      highlightAvailableSlots(
        true,
        selectedTreatments,
        _.merge(model, baseRequestModel),
        setLoadingTimeSlots,
        getFlag,
        resetTreatmentClickEvent,
        setActiveTreatment,
        getAccessToken,
      );
    }
  };

  return (
    <React.Fragment>
      {!showBulkCancel &&
        (!showBundleVisitsSidePanel && (
          <DockerPanel count={selectedTreatments.length} onCancel={onCancel} onSelectAll={onSelectAll}>
            {includeTreatments && (
              <IconButton
                aria-label="assign visits"
                color="inherit"
                size="small"
                className="docker-action-btn"
                disabled={disableWhenAnyStatementIsTrue(disableAssignVisitButton(selectedTreatments), isMultiAssign)}
                onClick={() => getAvailableTimeSpansForVisits()}
              >
                <span className="icon-extend icon-assign-visits" />
                <span style={{ fontSize: '14px', marginLeft: '5px' }}>{locale.getMsg('assignVisits')}</span>
              </IconButton>
            )}
            <IconButton
              aria-label="bundle visits"
              color="inherit"
              size="small"
              className="docker-action-btn"
              disabled={disableWhenAnyStatementIsTrue(disableBundleVisitButton(selectedTreatments), isMultiAssign)}
              onClick={() => setBundleVisitSidePanel(true)}
            >
              <span className="icon-extend icon-bundle-visits icon-small" />
              <span style={{ fontSize: '14px', marginLeft: '5px' }}>{locale.getMsg('bundleVisits')}</span>
            </IconButton>
            <IconButton
              aria-label="cancel visits"
              color="inherit"
              size="small"
              className="docker-action-btn"
              disabled={disableWhenAnyStatementIsTrue(
                selectedTreatments.filter(x => x.isBundled === true).length > 0,
                isMultiAssign,
              )}
              onClick={() => setShowBulkCancel(true)}
            >
              <RemoveCircleIcon />
              <span style={{ fontSize: '14px', marginLeft: '5px' }}>{locale.getMsg('cancelVisits')}</span>
            </IconButton>
          </DockerPanel>
        ))}
      {showBulkCancel && (
        <BulkCancel items={selectedTreatments} toggleRefresh={toggleRefresh} includeTreatments={includeTreatments} />
      )}
      {showBundleVisitsSidePanel && (
        <BundleVisitsDetails items={selectedTreatments} onCancel={onCancel} toggleRefresh={toggleRefresh} />
      )}
    </React.Fragment>
  );
}
